<template>
<div class="card p-2" :style="style">
  <slot></slot>
</div>
</template>

<script setup lang="ts">

import { computed, CSSProperties } from 'vue';
import { Color } from '@/store/theme.store';
import { useTheme } from '@/composable/ui/useTheme';

const props = defineProps({
  color: {
    type: String as () => Color,
    default: 'white',
  },
  borderColor: {
    type: String as () => Color,
    default: 'black',
  },
  borderWidth: {
    type: Number,
    default: 1,
  },
  borderStyle: {
    type: String as () => CSSProperties['borderStyle'],
    default: 'solid',
  },
  borderRadius: {
    type: String,
    default: 'var(--borderRadius)',
  },
  displayTitleBackground: {
    type: Boolean,
    default: false,
  },
  hasBorder: {
    type: Boolean,
    default: true,
  }
});

const theme = useTheme();

const style = computed((): CSSProperties => ({
  backgroundColor: theme.resolveColor(props.color),
  backgroundImage: props.displayTitleBackground
    ? `linear-gradient(to bottom, var(--primary) 40px, ${theme.resolveColor(props.color)} 1px)`
    : '',
  border: props.hasBorder ? theme.resolveColor(props.borderColor) : undefined,
  borderWidth: props.hasBorder ? `${props.borderWidth}px` : undefined,
  borderStyle: props.hasBorder ? props.borderStyle : undefined,
  borderRadius: props.borderRadius,
}));

</script>

<style scoped>

.card {
  padding: 5px 0 20px 0;
  border-radius: var(--borderRadius);
}

</style>
